import styled from "styled-components";

import Text from "components/atoms/text/Text";

const TagItem = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: ${(props) => props.$margin || "0"};
    padding: 0px 8px;
    max-width: 180px;
    height: 20px;
    outline: none;
    background-color: var(--color-Tag);
    border: transparent;
    border-radius: 4px;
    transition: all 120ms ease-in;
`;

export const CountTagItem = styled(TagItem)`
    margin: 0 0 0 8px;
    padding: 0px 4px;
    background-color: var(--color-BaseBlue);
`;

export const TagText = styled(Text).attrs((props) => ({
    variant: "btn-sm-500",
    color: "var(--color-SubBlack)",
}))`
    max-width: 200px;
`;
